import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Search } from "./SearchTypes";
import Components from "../Compoents";

const SAMPLE_HTML =
  `
<a component="result-block" href="">
  <picture component="rwd-picture" class="pic" lazy-loading="done">
    <source media="(max-width: 640px)" srcset="./static/images/search/result/1.m.png">
    <img src="./static/images/search/result/1.png" alt="something">
  </picture>
  <div class="details">
    <div class="title">【北竿南竿皆可登船】馬祖-大坵島-台版奈良尋鹿之旅</div>
    <div class="hashtags">
      <div class="tag">6人成團</div>
    </div>
    <div class="polyfill"></div>
    <div class="gap-line gray-300-h"></div>
    <div class="polyfill"></div>
    <div class="text">馬祖唯一打造遊艇船艙的客船【夏日之夢】，喝杯飲料吹吹海風，帶著您的【夢幻探險包】開啟這趟拋開城市喧囂的探險之旅。</div>
    <div class="rating-part">
      <div class="rating" manual-bind="false" component="rating-stars" data-rating="3" color="orange">
        <div class="value" style="background-color: orange; width: 60%;"></div>
      </div>
      <div class="rating-count">222</div>
    </div>
  </div>
</a>
`;

export default class ResultBlock extends ComponentBase {
  static generate(data: Search.Result) {
    let $elem = $(SAMPLE_HTML);
    $elem.find(`.title`).text(data.title);
    $elem.find(`.text`).html(data.description);
    $elem.attr("href", data.href);
    let $tags = $elem.find(".hashtags");
    $tags.empty();
    data.tags.forEach((tagName: string) => {
      let $tag = $(`<div class="tag">${tagName}</div>`);
      $tags.append($tag);
    });
    $elem.find(`.rating-count`).text(data.rating.count);
    $elem.find(`.rating`)[0].dataset.rating = String(data.rating.score);
    $elem.find(`img`).attr("src", data.picture.pc).attr("alt", data.title);
    $elem.find(`source`).attr("srcset", data.picture.mobile);
    let component = new ResultBlock($elem[0]);
    Components.bindScripts($elem[0]);
    return component;
  }

  constructor(elem: ComponentElem) {
    super(elem);
  }
}